module.exports = "img/18.13c90d.webp";